export default "__VITE_ASSET__Lj$FxV69__"